import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import * as L from "leaflet"
import { Geolocation } from "../../models"

const iconRetinaUrl = "assets/marker-icon-2x.png"
const iconUrl = "assets/marker-icon.png"
const shadowUrl = "assets/marker-shadow.png"
const iconDefault = L.icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
})
L.Marker.prototype.options.icon = iconDefault

@Component({
    selector: "valben-map-dialog",
    standalone: true,
    imports: [MatDialogContent, MatDialogClose, MatIcon],
    template: `
        <button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
            <mat-icon>close</mat-icon>
        </button>
        <mat-dialog-content class="!max-h-[80vh] h-[80vh]">
            <div class="h-full w-full flex">
                <div #mapEl class="border-4 rounded-md border-valamargray h-full w-full min-h-[500px]"></div>
                @if (!data.latitude && !data.longitude) {
                    <p>Nema podataka za prikaz.</p>
                }
            </div>
        </mat-dialog-content>
    `,
})
export class MapDialogComponent implements AfterViewInit, OnDestroy {
    readonly data = inject<Geolocation>(MAT_DIALOG_DATA)

    @ViewChild("mapEl") private _mapEl!: ElementRef<HTMLElement>
    private _map: L.Map | null = null

    ngAfterViewInit(): void {
        if (!this.data.latitude || !this.data.longitude) return

        const ll = L.latLng(this.data.latitude, this.data.longitude)
        this._map = L.map(this._mapEl.nativeElement, { center: ll, zoom: 7 })
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 18,
            minZoom: 8,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            referrerPolicy: "strict-origin-when-cross-origin",
        }).addTo(this._map)
        L.marker(ll).addTo(this._map)
    }

    ngOnDestroy(): void {
        this._map?.remove()
    }
}
